class TabGroup extends HTMLElement {
  connectedCallback() {
    this.nav = this.querySelector('.tabs__navigation');
    this.panels = this.querySelectorAll('.tabs__panel');

    this.#buildNav();
    this.buttons = this.querySelectorAll('.tabs__button');
    this.#activateTab(this.buttons[0]);

    for (const button of this.buttons) {
      button.addEventListener('click', () => this.#activateTab(button));
      button.addEventListener('keydown', (event) => this.#handleKeydown(event));
    }
  }

  #buildNav() {
    for (const panel of this.panels) {
      const template = panel.previousElementSibling;
      const label = template?.dataset.tabLabel ?? '';
      const button = document.createElement('button');

      button.className = 'tabs__button';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', 'false');
      button.setAttribute('aria-controls', panel.id);
      button.setAttribute('tabindex', '-1');
      button.textContent = label;

      this.nav.appendChild(button);
    }
  }

  #activateTab(selectedButton) {
    for (const button of this.buttons) {
      const isSelected = button === selectedButton;
      button.setAttribute('aria-selected', isSelected);
      button.tabIndex = isSelected ? 0 : -1;
    }

    for (const panel of this.panels) {
      const isActive = panel.id === selectedButton.getAttribute('aria-controls');
      panel.classList.toggle('tabs__panel--active', isActive);
      panel.hidden = !isActive;
    }
  }

  #handleKeydown(event) {
    const buttonsArray = [...this.buttons];
    const currentIndex = buttonsArray.indexOf(event.target);
    let newIndex;

    switch (event.key) {
      case 'ArrowRight':
        newIndex = (currentIndex + 1) % buttonsArray.length;
        break;
      case 'ArrowLeft':
        newIndex = (currentIndex - 1 + buttonsArray.length) % buttonsArray.length;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = buttonsArray.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    buttonsArray[newIndex].focus();
    this.#activateTab(buttonsArray[newIndex]);
  }
}

if (!customElements.get('tab-group')) {
  customElements.define('tab-group', TabGroup);
}
